const init = () => {

  // we need to apply a focusin/focusoutto cards due to the way the links are applied
  // we are attaching a class which in turn allows us to hook up some CSS
  $('.js-card').focusin(function () {
    $(this).addClass('on-focus');
  });

  $('.js-card').focusout(function () {
    $(this).removeClass('on-focus');
  });

  // fix for Umbraco forms single checkbox element to enable custom styling
  $('.umbraco-forms-field.checkbox').each((index, el) => {
    let $this = $(el);
    $this.find('label').insertAfter($this.find('input'));
  });

  // Enable modal on elements
  $('.js-modal').magnificPopup({
    type: 'image'
  });

  // Add additional margin to bottom of page when sticky bar is sat at bottom of page
  if ($('.brochure-sticky').length) {
    $('.footer-tertiary').css('margin-bottom', '72px');
  };

};

export {
  init
}